import { createWebHashHistory, createRouter, createWebHistory } from "vue-router";

// Views

import Home from "@/views/Home.vue";
import FeaturesTemplate from "@/views/FeaturesTemplate.vue";
import About from "@/views/About.vue";
import Contact from "@/views/Contact.vue";
import Editor from "@/views/Editor.vue";
import Preview from "@/views/Preview.vue";
import Login from "@/views/Login.vue";
import NoAccess from "@/views/NoAccess.vue";
import Library from "@/views/Library.vue";
import DashboardView from "@/views/Dashboard.vue";
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/:siteid/",
    name: "Home",
    component: Home,
  },
  {
    path: "/library",
    name: "Library",
    component: Library,
  },
  {
    path: "/noaccess",
    name: "NoAccess",
    component: NoAccess,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/:siteid/editor/:id",
    name: "Editor",
    component: Editor,
  },
  {
    path: "/:siteid/preview/:id",
    name: "Preview",
    component: Preview,
  },
  {
    path: "/:siteid/articlesdashboard",
    name: "DashboardView",
    component: DashboardView,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
